const { instance } = require('./url')


function getDownloadFileLink(id, filename='temp.pdf') {
    const index = filename.lastIndexOf('/')
    filename = filename.substr(index+1)
    return '/api/file/' + id + '/' + filename
}

async function downloadFile(id, filename='temp.pdf') {
    window.location.href = getDownloadFileLink(id, filename)
}

async function getFiles(quoteId) {
    return instance.get('/file/' + quoteId)
}

async function getFilesFromManyQuoteIDs(quoteIds) {
    return instance.post('/file/getQuotesFiles', {
        'ids': quoteIds,
    })
}

async function deleteFiles(id) {
    return instance.delete('/file/' + id)
}

async function uploadGlobalFile(id, file, onUploadProgress) {
    let formData = new FormData()
    formData.append("file", file)
    return await instance.post('/file/global/' + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
    })
}

async function uploadFile(quoteId, file, onUploadProgress) {
    let formData = new FormData()
    formData.append("file", file)

    return await instance.post('/file/' + quoteId, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    })
}

async function updateFileName(fileId, newFileName) {
    return await instance.put('/file/' + fileId, {
        name: newFileName,
    })
}

// name is passed explicitly (not relying on blob.name) since a
// clipboard-pasted Blob has no filename of its own - the caller always
// supplies the full display name (e.g. "Drawing Images/{given_id}/...").
async function replaceDrawingImage(quoteId, signGivenId, category, blob, name, onUploadProgress) {
    let formData = new FormData()
    formData.append("file", blob, name)

    return await instance.put(
        '/file/' + quoteId + '/drawing/' + signGivenId + '/' + category,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        },
    )
}

// Quote-level, never associated with a sign - always overwrites whatever
// was previously saved for this quote (see replaceDrawingImage/
// DRAWING_DATA.md's "PDF export" section).
async function saveGeneratedDrawingDataPdf(quoteId, pdfBlob, name, onUploadProgress) {
    let formData = new FormData()
    formData.append("file", pdfBlob, name)

    return await instance.put(
        '/file/' + quoteId + '/generatedpdf',
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        },
    )
}

export {
    getDownloadFileLink,
    downloadFile,
    uploadFile,
    uploadGlobalFile,
    replaceDrawingImage,
    saveGeneratedDrawingDataPdf,
    updateFileName,
    getFiles,
    getFilesFromManyQuoteIDs,
    deleteFiles,
}

